import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';

import { HotTableModule } from '@handsontable/angular';

import { TableComponent } from './table.component';
import { TableSonsComponent } from './tableSons.component';
import { CoverUploadComponent } from '../../components/coverupload/coverUpload.component';
import { WaveformComponent } from '../../components/waveform/waveform.component';
import { CoverSearchComponent } from '../../components/coversearch/coverSearch.component';
import { TmdbSearchComponent } from '../../components/tmdbsearch/tmdbSearch.component';
import { ArtistPictureSearch } from 'src/app/components/artistpicturesearch/artistPictureSearch.component';
import { ArtistInstagramSearch } from 'src/app/components/artistinstagramsearch/artistInstagramSearch.component';
import { ChoiceWinmediaComponent } from '../../components/choicewinmedia/choiceWinmedia.component';
import { VersionDatepickerComponent } from '../../components/versiondatepicker/versionDatepicker.component';
import { MetadataReviewComponent } from '../../components/metadatareview/metadataReview.component';

import { AnalyzerService } from '../../providers/Table/analyzer.service';
import { MusicsDataService } from '../../providers/Table/musicsData.service';
import { UploadCoverService } from '../../providers/Table/uploadCover.service';

import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { TimeFormatPipe } from '../../components/waveform/time-format.pipe';
import { UrlCoverSizeFormatPipe } from '../../components/coversearch/url-cover-size-format.pipe';

@NgModule({
  declarations: [
    TableComponent,
    TableSonsComponent,
    CoverUploadComponent,
    WaveformComponent,
    CoverSearchComponent,
    TmdbSearchComponent,
    ArtistPictureSearch,
    ArtistInstagramSearch,
    ChoiceWinmediaComponent,
    VersionDatepickerComponent,
    MetadataReviewComponent,
    TimeFormatPipe,
    UrlCoverSizeFormatPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    HotTableModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatIconModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule
  ],
  providers: [
    AnalyzerService,
    MusicsDataService,
    UploadCoverService,
    MatDatepickerModule
  ]
})
export class TableModule { }
